import { memo } from "react";
import Link from "next/link";
import { Container, Row, Col } from "react-bootstrap";
import Logo from "../logo";

const FooterDefault = memo(() => {
  return (
    <footer className="footer footer-default">
      <Container fluid>
        <Row>
          <Col lg={3} md={6} sm={6}>
            <div className="footer-logo pt-4">
              <div className="d-flex align-items-center">
                <Logo />
              </div>
              <p className="mt-3">
                Empowering your yoga journey with mindful practices and expert guidance.
              </p>
              <div className="social-icons mt-4">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="me-3">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="me-3">
                  <i className="fab fa-facebook"></i>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </Col>
          <Col lg={3} md={6} sm={6}>
            <div className="widget">
              <h5 className="footer-title">Videos</h5>
              <ul className="list-unstyled mb-0">
                <li><Link href="/videos">All Videos</Link></li>
                <li><Link href="/categories/yoga-flows">Yoga Flows</Link></li>
                <li><Link href="/categories/foundation-courses">Foundation Courses</Link></li>
                <li><Link href="/categories/mini-courses">Mini Courses</Link></li>
                <li><Link href="/categories/cyclical-practices">Cyclical Practices</Link></li>
                <li><Link href="/categories/live-recordings">Live Recordings</Link></li>
              </ul>
            </div>
          </Col>
          <Col lg={3} md={6} sm={6}>
            <div className="widget">
              <h5 className="footer-title">Quick Links</h5>
              <ul className="list-unstyled mb-0">
                <li><Link href="/events">Live Events</Link></li>
                <li><Link href="/about">About</Link></li>
                <li><Link href="/profile">My Profile</Link></li>
                <li><Link href="/profile/library">My Library</Link></li>
                <li><Link href="/profile/history">Watch History</Link></li>
              </ul>
            </div>
          </Col>
          <Col lg={3} md={6} sm={6}>
            <div className="widget">
              <h5 className="footer-title">Newsletter</h5>
              <p className="mb-4">Subscribe to our newsletter and stay updated with the latest content.</p>
              <form className="position-relative">
                <input
                  type="email"
                  className="form-control rounded-pill"
                  placeholder="Enter your email"
                  required
                />
                <button
                  type="submit"
                  className="btn btn-theme rounded-pill position-absolute end-0 top-0 h-100"
                >
                  Subscribe
                </button>
              </form>
              <small className="form-text text-muted mt-2">
                By subscribing, you agree to our Privacy Policy and consent to receive updates.
              </small>
            </div>
          </Col>
        </Row>
        <hr className="mt-5 mb-4" />
        <Row className="align-items-center">
          <Col md={6}>
            <p className="mb-0">
              © {new Date().getFullYear()} All Rights Reserved.
            </p>
          </Col>
          <Col md={6}>
            <ul className="list-inline text-md-end mb-0">
              <li className="list-inline-item">
                <Link href="/privacy-policy">Privacy Policy</Link>
              </li>
              <li className="list-inline-item ms-4">
                <Link href="/terms">Terms of Use</Link>
              </li>
              <li className="list-inline-item ms-4">
                <Link href="/contact">Contact</Link>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
});

FooterDefault.displayName = "FooterDefault";
export default FooterDefault;
